define("shared/components/shared/pre-boarding/survey-components/image-block-selector", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Ui::Button
    @onClick={{fn @selectRadioButtonResponse @question.identifier @option.value}}
    @variant="unstyled"
    class={{concat-classes
      "tUG--questionCard__input"
      "tUG--questionCard__input--imgSelect"
      "u--p__xs"
      @question.class
      @option.qaClass
      (if this.isSelected "is--active" "is--disable")
    }}
    data-test-survey="image-block-selector"
    {{(modifier
      "touch-gesture"
      onTouchEnd=(fn @onTouchEnd @question.identifier @option.value)
      onTouchStart=@onTouchStart
      onTouchMove=@onTouchMove
    )}}
  >
    <img alt={{@question.identifier}} class="o--media tUG--questionCard__media u--m__b__xs" src={{@option.icon}} />
    <h4 class="u--m__t__0 u--m__b__xs">{{@option.text}}</h4>
    <p class="u--m__tb__0 u--text--xs u--text--light">{{@option.subText}}</p>
  </Shared::Ui::Button>
  */
  {
    "id": "JLz4FZo9",
    "block": "[[[8,[39,0],[[16,0,[28,[37,1],[\"tUG--questionCard__input\",\"tUG--questionCard__input--imgSelect\",\"u--p__xs\",[30,1,[\"class\"]],[30,2,[\"qaClass\"]],[52,[30,0,[\"isSelected\"]],\"is--active\",\"is--disable\"]],null]],[24,\"data-test-survey\",\"image-block-selector\"],[4,[50,[28,[37,5],[\"modifier:touch-gesture\"],null],2,null,[[\"onTouchEnd\",\"onTouchStart\",\"onTouchMove\"],[[28,[37,3],[[30,4],[30,1,[\"identifier\"]],[30,2,[\"value\"]]],null],[30,5],[30,6]]]],null,null]],[[\"@onClick\",\"@variant\"],[[28,[37,3],[[30,3],[30,1,[\"identifier\"]],[30,2,[\"value\"]]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n  \"],[10,\"img\"],[15,\"alt\",[30,1,[\"identifier\"]]],[14,0,\"o--media tUG--questionCard__media u--m__b__xs\"],[15,\"src\",[30,2,[\"icon\"]]],[12],[13],[1,\"\\n  \"],[10,\"h4\"],[14,0,\"u--m__t__0 u--m__b__xs\"],[12],[1,[30,2,[\"text\"]]],[13],[1,\"\\n  \"],[10,2],[14,0,\"u--m__tb__0 u--text--xs u--text--light\"],[12],[1,[30,2,[\"subText\"]]],[13],[1,\"\\n\"]],[]]]]]],[\"@question\",\"@option\",\"@selectRadioButtonResponse\",\"@onTouchEnd\",\"@onTouchStart\",\"@onTouchMove\"],false,[\"shared/ui/button\",\"concat-classes\",\"if\",\"fn\",\"modifier\",\"-resolve\"]]",
    "moduleName": "shared/components/shared/pre-boarding/survey-components/image-block-selector.hbs",
    "isStrictMode": false
  });
  class ImageBlockSelectorComponent extends _component2.default {
    get isSelected() {
      return this.args.surveyResponses[this.args.question.identifier] === this.args.option.value;
    }
  }
  _exports.default = ImageBlockSelectorComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ImageBlockSelectorComponent);
});